// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"b4c0191b","977":"65a06352"}[chunkId] + ".chunk.js";
};